import type { Article } from '@/types';
import ArticleCard from '@/components/feature/ArticleCard';

export default function RelatedList({ articles }: { articles: Article[] }) {
  if (articles.length === 0) return null;
  return (
    <section className="mt-10">
      <h2 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-4">
        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
          <i className="ri-links-line text-sm" />
        </span>
        相关推荐
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {articles.map((item) => (
          <ArticleCard key={item.id} article={item} layout="list" showSummary={false} />
        ))}
      </div>
    </section>
  );
}